import { extractDynamicContentParams } from 'conversional-iframe-dom';
export var CONFIG_ELEMENT_ID = 'conversional-journey';
export var getJourneySettings = function () {
    var _a, _b;
    var config = {
        api: null,
        version: null,
        key: null,
        journey: null,
        noCookies: null,
        result: null,
        bootstrap: null
    };
    var configElement = document.getElementById(CONFIG_ELEMENT_ID);
    for (var _i = 0, _c = Object.keys(config); _i < _c.length; _i++) {
        var key = _c[_i];
        if (configElement) {
            var configValue = configElement.getAttribute('data-' + key);
            if (configValue) {
                config[key] = configValue;
            }
        }
    }
    var dynamicContentParams = extractDynamicContentParams();
    if ((_a = dynamicContentParams === null || dynamicContentParams === void 0 ? void 0 : dynamicContentParams.contentParams) === null || _a === void 0 ? void 0 : _a.leadSource)
        config.journey = (_b = dynamicContentParams === null || dynamicContentParams === void 0 ? void 0 : dynamicContentParams.contentParams) === null || _b === void 0 ? void 0 : _b.leadSource;
    return config;
};
export var persistCurrentJourneyOnSettings = function (journeyId) {
    var configElement = document.getElementById(CONFIG_ELEMENT_ID);
    if (configElement) {
        configElement.setAttribute('data-active-journey', journeyId);
    }
};
export var getCurrentActiveJourney = function () {
    var configElement = document.getElementById(CONFIG_ELEMENT_ID);
    if (configElement) {
        return configElement.getAttribute('data-active-journey');
    }
    return null;
};
